module.exports = __webpack_public_path__ + "img/ptt.4736aa5d.png";